import React, { useCallback } from 'react'
import { TouchableOpacity } from 'react-native'

import { B1, B2, BTN_SM, Icon, SH3, Stack, XStack } from '@zet/design-system'

import Close from '../../assets/images/icons/close.svg'
import UploadedFilled from '../../assets/images/icons/uploadedFilled.svg'
import UploadingFilled from '../../assets/images/icons/uploadingFilled.svg'
import { usePlDocumentPicker } from '../../loans/personalLoan/usePlDocumentPicker'
import { UserDetailsProps } from '../../types'
import { ProgressBarWithPercentage } from '../common/progressBarWithPercent'

interface Props {
  label: string
  fieldId: string
  code: string
  userDetails: UserDetailsProps
  onChange: (url: string) => null
  placeholder: string | null
  config: {
    required: boolean
  }
}

const PLDocumentUpload = ({
  label = '',
  fieldId,
  code,
  userDetails,
  onChange,
  placeholder,
  config,
}: Props) => {
  const {
    pickDocument,
    documentName,
    isUploaded,
    isUploading,
    removeDoc,
    uploadProgress,
  } = usePlDocumentPicker(code, userDetails, onChange, placeholder, config)

  const showTextForSpecificCodes = (code: string) => {
    switch (code) {
      // case 'filePan':
      //   return { doc: 'Upload Pan Card', required: true }
      // case 'fileAadharFront':
      //   return { doc: 'Upload Aadhar Card', required: true }
      // case 'fileForm16':
      //   return { doc: 'Upload Form-16', required: false }
      case 'filePayslip1':
        return { doc: 'Upload Latest Payslip', required: true }
      // case 'fileBankStatement':
      //   return { doc: 'Upload Bank Statement (Last 6 months)', required: true }
      // case 'fileCompanyId':
      //   return {
      //     doc: 'Upload Company ID Card (Current Company)',
      //     required: false,
      //   }
      // case 'filePayslip3':
      //   return { doc: 'file', required: true }
      // case 'fileAadharBack':
      //   return { doc: 'file', required: true }
      default:
        return undefined
    }
  }

  const handleCancel = useCallback(() => {
    removeDoc(fieldId, true)
  }, [])

  return (
    <>
      <Stack className="mx-1 mt-1">
        {showTextForSpecificCodes(code)?.doc !== 'file' &&
        typeof showTextForSpecificCodes(code)?.doc !== 'undefined' ? (
          <SH3 className="pb-2 text-base text-[#36383F]">
            {showTextForSpecificCodes(code)?.doc}
            {showTextForSpecificCodes(code)?.required ? (
              <B1 className="text-error-100 ml-1">*</B1>
            ) : (
              <></>
            )}
          </SH3>
        ) : null}
        <XStack className="flex-1 items-center justify-between">
          <Stack className="flex-1">
            <XStack className="items-center">
              {isUploaded ? (
                <Stack className="pr-1">
                  <UploadedFilled width={15} height={15} />
                </Stack>
              ) : isUploading ? (
                <Stack className="pr-1">
                  <UploadingFilled width={15} height={15} />
                </Stack>
              ) : null}
              <B2 className=" text-[#36383F]">
                <B2 className="text-[#36383F]">{documentName || label}</B2>
              </B2>
            </XStack>
            {isUploading && !isUploaded ? (
              <ProgressBarWithPercentage
                isCompleted={false}
                widthPercentage={uploadProgress || 0}
              />
            ) : null}
          </Stack>
          {isUploading || isUploaded ? (
            <TouchableOpacity onPress={handleCancel} className="flex-none">
              <Close width={22} height={22} />
            </TouchableOpacity>
          ) : (
            <TouchableOpacity
              onPress={() => pickDocument(fieldId)}
              className="bg-primary-10 w-28 flex-row items-center justify-between rounded-md px-2 py-1"
            >
              <Icon
                type="UploadFilled"
                color="#2075F0"
                width={20}
                height={20}
              />
              <BTN_SM className="text-primary-100 text-sm">Upload File</BTN_SM>
            </TouchableOpacity>
          )}
        </XStack>
      </Stack>
      {showTextForSpecificCodes(code)?.doc &&
      (code !== 'filePayslip1' || code === 'filePayslip3') &&
      code !== 'fileAadharFront' ? (
        <Stack className="border-b-2 border-[#ECEFF5] pb-3 pt-2" />
      ) : null}
    </>
  )
}

export default PLDocumentUpload
